import { useRecoilState, useRecoilValue } from "recoil";
import { deviceListState } from "../atom/atom";
import { Device, Token } from "../types/type";
import PushNotificationForm from "../components/PushNotificationForm";
import { useEffect } from "react";
import { fetchAndSetData, fetchDeviceList } from "../api/fetch.api";

function DevicePage() {
  const [deviceList, setDeviceList] = useRecoilState(deviceListState);

  const loggedInDeviceList = deviceList
    .filter((device: Device) => device.email)
    .sort((a: Device, b: Device) => {
      const dateA = a.recentlyUseAt ? a.recentlyUseAt.toDate() : 0;
      const dateB = b.recentlyUseAt ? b.recentlyUseAt.toDate() : 0;
      return dateB - dateA; // Sort in descending order
    });

  const nonLoggedInDeviceList = deviceList
    .filter((device: Device) => !device.email)
    .sort((a: Token, b: Token) => {
      const dateA = a.recentlyUseAt ? a.recentlyUseAt.toDate() : 0;
      const dateB = b.recentlyUseAt ? b.recentlyUseAt.toDate() : 0;
      return dateB - dateA; // Sort in descending order
    });

  const formatDate = (timestamp: any) => {
    if (!timestamp) return "";
    const date = timestamp.toDate();
    return date.toLocaleString(); // Convert to a locale string format
  };

  useEffect(() => {
    if (deviceList.length == 0) {
      fetchAndSetData(fetchDeviceList, setDeviceList);
    }
  }, [deviceList]);

  return (
    <>
      <div style={{ marginBottom: "20px" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            gap: "10px",
          }}
        >
          <div>
            <h1>Device Data</h1>
            <div style={{ display: "flex", justifyContent: "flex-start" }}>
              <h2>로그인</h2>
              <h2>{loggedInDeviceList.length}명</h2>
            </div>
          </div>
        </div>
        {loggedInDeviceList.map((device: Device) => (
          <div
            key={device.fcmToken}
            style={{
              border: "1px solid #ccc",
              margin: "10px",
              padding: "10px",
            }}
          >
            <p>device Id : {device.deviceId}</p>
            <p>hashed device Id : {device.hashedDeviceId}</p>
            <p>유저 이름: {device.userName}</p>
            <p>유저 이메일: {device.email}</p>
            <p>플랫폼: {device.platform}</p>
            <p>마지막 접속: {formatDate(device.recentlyUseAt)}</p>
            <p>토큰: {device.fcmToken}</p>
          </div>
        ))}
      </div>

      <div style={{ marginBottom: "20px" }}>
        <div
          style={{ display: "flex", justifyContent: "flex-start", gap: "10px" }}
        >
          <h2>비로그인</h2>
          <h2>{nonLoggedInDeviceList.length}명</h2>
        </div>

        {nonLoggedInDeviceList.map((token: Token) => (
          <div
            key={token.fcmToken}
            style={{
              border: "1px solid #ccc",
              margin: "10px",
              padding: "10px",
            }}
          >
            <p>토큰: {token.fcmToken}</p>
            <p>플랫폼: {token.platform}</p>
            <p>마지막 접속: {formatDate(token.recentlyUseAt)}</p>
          </div>
        ))}
      </div>
    </>
  );
}

export default DevicePage;
